module.exports = __webpack_public_path__ + "static/media/icon_card_normal.9818df87.svg";